import React, { useState } from "react";
import {
    EnterLicenseModalContainer,
    EnterLicenseModalContentContainer,
    EnterLicenseModalTitle,
    EnterLicenseButton,
    BuyNowButton,
    ButtonContainer,
    Input,
    ModalText,
} from "./EnterLicenseModal.styles";
import { useLanguage } from "../../../../core/translations/LanguageContext";
import { SupportedLanguage } from "../../../../core/translations/supportedLanguages";
import { EnterLicenseModalTranslations } from "./translations/types";
import { enTranslations } from "./translations/en";
import { deTranslations } from "./translations/de";
import GlobalSmallPopup from "../../../core/modal/GlobalSmallPopup";

const TRANSLATIONS: Record<SupportedLanguage, EnterLicenseModalTranslations> = {
    en: enTranslations,
    de: deTranslations,
};

interface AddLicenseType {
    (token: string, payload: { license_key: string }): Promise<{ status: number; message: string }>;
}

interface EnterLicenseModalProps {
    onEnterLicenseClose: () => void;
    addLicense: any;
}

const EnterLicenseModal: React.FC<EnterLicenseModalProps> = ({
                                                                 onEnterLicenseClose,
                                                                 addLicense
                                                             }) => {
    const { language } = useLanguage();
    const translations = TRANSLATIONS[language];
    const [licenseKey, setLicenseKey] = useState("");
    const [error, setError] = useState<string | null>(null);

    return (
        <GlobalSmallPopup onRequestClose={onEnterLicenseClose}>
            <EnterLicenseModalContainer>
                <EnterLicenseModalContentContainer>
                    <EnterLicenseModalTitle>
                        {translations.title}
                    </EnterLicenseModalTitle>
                    <Input
                        value={licenseKey}
                        onChange={(e) => setLicenseKey(e.target.value)}
                        placeholder={"AAAA-BBBB-CCCC-DDDD"}
                    />
                    {error && <ModalText>{error}</ModalText>}
                    <ButtonContainer>
                        <EnterLicenseButton onClick={() => addLicense(licenseKey)}>
                            {translations.submitButtonText}
                        </EnterLicenseButton>

                        <ModalText>
                            {translations.dontHaveLicenseText}
                            <BuyNowButton onClick={onEnterLicenseClose}>
                                {translations.buyNowButtonText}
                            </BuyNowButton>
                        </ModalText>
                    </ButtonContainer>
                </EnterLicenseModalContentContainer>
            </EnterLicenseModalContainer>
        </GlobalSmallPopup>
    );
};

export default EnterLicenseModal;
